import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class CompaniesService {
  public async getCompanies() {
    try {
      let response = await fetch(`${BASE_URL}/companies/`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async getCompany(companyId: String) {
    try {
      let response = await fetch(`${BASE_URL}/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async addCompany(companyData: any) {
    let jsonBody = JSON.stringify(companyData);
    try {
      let response = await fetch(`${BASE_URL}/companies/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async updateCompany(companyId: String, companyData: any) {
    let jsonBody = JSON.stringify(companyData);
    try {
      let response = await fetch(`${BASE_URL}/companies/${companyId}`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
  public async deleteCompany(companyId: String) {
    try {
      let response = await fetch(`${BASE_URL}/companies/${companyId}`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
}
